var locale = {
  today: function (loc) {
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1 // January is 0!
    var yyyy = today.getFullYear()
    if (dd < 10) { dd = '0' + dd }
    if (mm < 10) { mm = '0' + mm }
    if (loc === 'it') {
      today = dd + '/' + mm + '/' + yyyy
    } else {
      today = yyyy + mm + dd
    }
    return today
  },
  it: {
    months: {
      '01': 'Gennaio',
      '02': 'Febbraio',
      '03': 'Marzo',
      '04': 'Aprile',
      '05': 'Maggio',
      '06': 'Giugno',
      '07': 'Luglio',
      '08': 'Agosto',
      '09': 'Settembre',
      '10': 'Ottobre',
      '11': 'Novembre',
      '12': 'Dicembre'
    },
    monthNumber: function (date) {
      var no = date.slice(3, 5)
      return no
    },
    translate: function (name) {
      var itName = name
      switch (name) {
        case 'submitted':
          itName = 'In attesa'
          break
        case 'accepted':
          itName = 'Ammesso'
          break
        case 'active':
          itName = 'In regola'
          break
        case 'inactive':
          itName = 'Quota associativa scaduta'
          break
        default:
          itName = name
      }
      return itName
    }
  }
}

export default locale



// WEBPACK FOOTER //
// ./src/modules/locale.js